import { JwtHelper } from 'angular2-jwt';

export class Usuario {
    id: number;
    nome: string;
    login: string;
    email: string;
    senha: string;
    cpf: string;	
	perfis: string[];
	perfil_ids: number[];
	
  constructor(){
    let jwtHelper: JwtHelper = new JwtHelper();
    //let token = localStorage.getItem('token_acesso');
    //let tokenDecode = jwtHelper.decodeToken(token);

    //this.id = tokenDecode.id;
    //this.nome = tokenDecode.nome;
    //this.perfis = tokenDecode.perfis;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.ts